import React from 'react';
import { SVGComp, PathComp } from '../../components/Svgs';
import { useTheme } from '@hmsexp/component-library';

const WarningIconPopover = ({ width = '14', height = '14', viewBox = '0 0 14 14', stroke = "white" }) => {
  const theme = useTheme();
  return (
    <SVGComp width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <PathComp
        d="M7 4.6V7M7 9.4H7.006M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
        stroke={stroke}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVGComp>
  );
};

export default WarningIconPopover;
